import { Component, Input, OnInit, OnDestroy, Optional } from '@angular/core';
import { BllAccordionComponent } from './accordion.component';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { BllExpandPanelComponent } from '../expand';
import { bllExpansionAnimations } from '../expand/expansion-animations';
@Component({
  selector: 'bll-accordion-panel',
  templateUrl: './accordion-panel.component.html',
  host: {
    class: 'expand-item',
    '[class.open]': 'isOpen',
    '[class.disabled]': '!noDisabledClass && disabled',
  },
  animations: [bllExpansionAnimations.bodyExpansion],
})
@Input()
export class BllAccordionPanelComponent extends BllExpandPanelComponent implements OnInit, OnDestroy {
  @Input()
  get iconCenter(): any {
    return this._iconCenter != null ? this._iconCenter : this.accordion.iconCenter;
  }
  set iconCenter(value: any) {
    this._iconCenter = coerceBooleanProperty(value);
  }
  private _iconCenter: boolean;

  @Input()
  get iconClass(): string {
    return this._iconClass || this.accordion.iconClass;
  }
  set iconClass(value) {
    this._iconClass = value;
  }
  _iconClass: string;

  @Input()
  get iconArrow(): any {
    return this._iconArrow || this.accordion.iconArrow;
  }
  set iconArrow(value: any) {
    this._iconArrow = coerceBooleanProperty(value);
  }
  _iconArrow: boolean;

  @Input()
  get iconSize(): number {
    return this._iconSize || this.accordion.iconSize;
  }
  set iconSize(value: number) {
    this._iconSize = value;
  }
  _iconSize: number;

  @Input()
  get paddingContent(): boolean {
    return this._paddingContent != null ? this._paddingContent : this.accordion.paddingContent;
  }
  set paddingContent(value) {
    this._paddingContent = coerceBooleanProperty(value);
  }
  private _paddingContent: boolean;

  constructor(@Optional() private accordion: BllAccordionComponent) {
    super(accordion);
  }
}
